export default function Services() {
  const services = [
    {
      icon: 'ri-building-2-line',
      title: 'Construcción',
      description: 'Desarrollamos proyectos de construcción para hogares y espacios comerciales, con materiales de calidad y ejecución confiable.',
      image: 'https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/bf2c23d66ddf76b17c58ba06f25a8d10.webp',
    },
    {
      icon: 'ri-road-map-line',
      title: 'Obra Civil Ligera',
      description: 'Banquetas, bardas, losas, pisos y acabados estructurales con materiales de primera calidad.',
      image: 'https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/dcca06942caaaec3af4538118049b374.jpeg',
    },
    {
      icon: 'ri-door-line',
      title: 'Carpintería Residencial',
      description: 'Puertas, closets, cocinas integrales y muebles a medida para tu hogar con acabados de lujo.',
      image: 'https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/924c265a7a12b7ef4b6ab076a44d8821.jpeg',
    },
    {
      icon: 'ri-store-2-line',
      title: 'Carpintería Comercial',
      description: 'Muebles industriales de herrería y madera para negocios, oficinas y espacios comerciales.',
      image: 'https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/e891cc1edff12661c73891774becd401.png',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Instalaciones Eléctricas',
      description: 'Instalaciones residenciales y comerciales, corrección de fallas y actualización a normativas vigentes.',
      image: 'https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/bde3aa42d5a3c40ec1fd8123b578eb4f.webp',
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Remodelación',
      description: 'Transformamos espacios con remodelaciones funcionales, acabados duraderos y soluciones adaptadas a cada proyecto.',
      image: 'https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/3c5561e9741d75ce670a4be4fb01bb26.jpeg',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Impermeabilizaciones',
      description: 'Protección para techos y azoteas que alarga la vida útil de tus inmuebles y previene filtraciones.',
      image: 'https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/15a7e40a01ee808b33bd2065ae448124.png',
    },
    {
      icon: 'ri-tools-line',
      title: 'Mantenimiento Preventivo',
      description: 'Realizamos mantenimiento preventivo en instalaciones eléctricas, plomería y más, asegurando funcionamiento continuo.',
      image: 'https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/2c3457117165bef37bd2c3e69bcb6df8.jpeg',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Mantenimiento Correctivo',
      description: 'Realizamos mantenimiento correctivo en instalaciones eléctricas, plomería y más, asegurando funcionamiento continuo.',
      image: 'https://static.readdy.ai/image/4ebe2c70aa72ef2c6dfc01f370e8f72f/3910e1aaecfd253375cafea2e23b66a1.jpeg',
    },
  ];

  return (
    <section id="servicios" className="py-24 bg-[#F4F1EC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Encabezado */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-5 py-2 border-2 border-[#C9A86A] rounded-full mb-6">
            <span className="text-[#C9A86A] text-sm font-semibold tracking-wider uppercase">
              Nuestros Servicios
            </span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-heading font-bold text-[#1A1A2E] leading-tight mb-5">
            Servicios de construcción,<br />
            mantenimiento e instalaciones
          </h2>
          <p className="text-lg text-[#7D7D7D] max-w-2xl mx-auto leading-relaxed">
            Soluciones profesionales para hogares y negocios, con ejecución real y resultados duraderos.
          </p>
        </div>

        {/* Grid de servicios */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-[#C9A86A] transition-all duration-300"
            >
              {/* Imagen superior */}
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Contenido */}
              <div className="p-8">
                <div className="w-14 h-14 bg-[#C9A86A]/10 rounded-full flex items-center justify-center mb-5 group-hover:bg-[#C9A86A]/20 transition-colors">
                  <i className={`${service.icon} text-[#C9A86A] text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#2C3E50] mb-3">{service.title}</h3>
                <p className="text-[#7D7D7D] leading-relaxed text-sm">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Botón principal */}
        <div className="flex justify-center mt-16">
          <a
            href="#contacto"
            className="inline-flex items-center gap-3 bg-[#C9A86A] text-[#1A1A2E] text-base font-semibold px-10 py-4 rounded-full hover:bg-[#B8935A] transition-colors duration-300 whitespace-nowrap"
          >
            <i className="ri-file-list-3-line text-lg"></i>
            Solicitar Cotización
          </a>
        </div>
      </div>
    </section>
  );
}
